export default {
	title: 'Diagnostic Report',
	selectOrg: 'Select Organization',
	selectAll: 'Select All',
	selectedItems: 'Selected {count} items',
	batchDelete: 'Batch Delete',
	batchDeleteWithCount: 'Batch Delete ({count})',
	sendEmail: 'Send Email',
	sendEmailWithCount: 'Send Email ({count})',
	noData: {
		title: 'No Diagnostic Reports',
		description: 'No relevant diagnostic report data found'
	},
	reportCard: {
		coverAlt: 'Diagnostic Report Cover',
		maker: 'Author',
		updateTime: 'Update Time'
	},
	actions: {
		check: 'Check',
		download: 'Download',
		modify: 'Modify',
		delete: 'Delete',
		sendEmail: 'Send Email',
		batchDelete: 'Batch Delete'
	},
	configDialog: {
		title: 'Diagnostic Report Check',
		reportConfig: 'Report Check',
		warnConfig: 'Alarm Check',
		projectName: 'Project Name',
		deviceName: 'Device Name',
		reportTime: 'Report Generation Time',
		author: 'Author',
		warnItem: 'Alarm Item',
		delete: 'Delete',
		faultLocation: 'Fault Location',
		faultType: 'Fault Type',
		selectFaultType: 'Please select fault type',
		alarmLevel: 'Alarm Level',
		selectAlarmLevel: 'Please select alarm level',
		alarmCount: 'Alarm Count',
		diagnosisAnalysis: 'Diagnosis Analysis',
		enterDiagnosisAnalysis: 'Please enter diagnosis analysis',
		relatedAtlas: 'Related Atlas',
		addAtlas: 'Add Atlas',
		diagnosisConclusion: 'Diagnosis Conclusion',
		enterDiagnosisConclusion: 'Please enter diagnosis conclusion',
		maintenanceSuggestion: 'Maintenance Suggestion',
		enterMaintenanceSuggestion: 'Please enter maintenance suggestion',
		alarmStartTime: 'Alarm Start Time',
		alarmEndTime: 'Alarm End Time',
		selectDateTime: 'Select date and time',
		regenerate: 'Regenerate'
	},
	emailDialog: {
		title: 'Send Email',
		ccPerson: 'CC Person',
		selectCcPerson: 'Please select CC person',
		cancel: 'Cancel',
		confirm: 'Confirm'
	},
	messages: {
		selectReportWarning: 'Please select diagnostic report',
		selectCcPersonWarning: 'Please select CC person',
		sendSuccess: 'Sent successfully',
		deleteConfirm: 'Are you sure to delete the selected {count} items?',
		deleteSuccess: 'Deleted successfully',
		selectDeleteWarning: 'Please select records to delete',
		configSuccess: 'Diagnostic report configured successfully',
		uploadImageError: 'Only image files can be uploaded!',
		uploadImageSizeError: 'Image size cannot exceed 5MB!',
		selectedCount: 'Selected {count} item(s)',
		operateSuccess: 'Operation successful'
	},
	form: {
		fileName: 'Report Name',
		startTime: 'Start Time',
		endTime: 'End Time',
		reportTitle: 'Report Title',
		maker: 'Author',
		orgId: 'Department',
		result: 'Diagnostic Result',
		fileViewInDoc: 'View in document',
		diagnosticReport: 'Diagnostic Report',
		requiredFieldCannotBeEmpty: 'Required field cannot be empty',
		add: 'Add',
		update: 'Update'
	},
	table: {
		reportTitle: 'Report Title',
		diagnosticReport: 'Diagnostic Report',
		maker: 'Author',
		orgId: 'Department',
		result: 'Diagnostic Result',
		updateTime: 'Diagnostic Time'
	}
}
